import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Chakra } from "@airhelp/react-ui-components";
import { useTranslations } from "contexts/LocalizationContext";
import SingleFlag from "../SingleFlag/SingleFlag";
import FlagText from "../FlagText/FlagText";
import { MONTREAL_ANIMATED_FLAGS } from "../consts";

const { Box, Flex } = Chakra;

const MontrealAnimatedFlag = () => {
  const [iconIndex, setIconIndex] = useState(0);
  const translations = useTranslations();
  const MotionBox = motion(Box);

  useEffect(() => {
    const interval = setInterval(() => {
      setIconIndex((item) => (item + 1 > MONTREAL_ANIMATED_FLAGS.length - 1 ? 0 : item + 1));
    }, 3000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex align="center" data-testid="animated-flags-hero">
      <MotionBox
        key={iconIndex}
        animate={{
          opacity: [0, 1, 1, 0],
        }}
        transition={{
          duration: 3,
          times: [0, 0.3, 0.95, 1],
        }}
      >
        <SingleFlag flag={MONTREAL_ANIMATED_FLAGS[iconIndex]} />
      </MotionBox>
      <FlagText text={translations("montreal_convention")} />
    </Flex>
  );
};

export default MontrealAnimatedFlag;
